import echarts from "echarts";
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import NativeObject from "../../../components/NativeObject/NativeObject";
import Card from "../../../components/Cards/Card";

function GeneralMobile({ app, config, filter }) {
  const { cards } = config.performanceDetail;
  const { title, tooltip, customRadio, legends, comboCharts } = cards[0];
  const [alignment, setAlignment] = useState("Sell Out");
  const tooltips = {
    "Regionais": {
      "Sell Out": "Ranking de Performance percentual de sell out por regional",
      "Cobertura Total": "Ranking de Cobertura Total em percentual por regional",
      "Cobertura Qualificada": "Ranking de Cobertura Qualificada em percentual por regional",
    },
    "Grupos Distribuidores": {
      "Sell Out": "Ranking de Performance percentual de sell out por distribuidor",
      "Cobertura Total": "Ranking de Cobertura Total em percentual por distribuidor",
      "Cobertura Qualificada": "Ranking de Cobertura Qualificada em percentual por distribuidor",
    },
    "Detalhamento": {
      "Sell Out": "O detalhamento de performance de sell out mostra a Meta vs Realizado por regional e clicando na seta de + você pode ter a visão por distribuidor",
      "Cobertura Total": "O detalhamento de Cobertura Total mostra a Meta vs Realizado por regional e clicando na seta de + você pode ter a visão por distribuidor",
      "Cobertura Qualificada": "O detalhamento de Cobertura Qualificada mostra a Meta vs Realizado por regional e clicando na seta de + você pode ter a visão por distribuidor. Importante: Na cobertura qualificada o distribuidor pontua positivando ao menos 5 dos 6 sku's do Sortimento Mínimo do canal",
    },
  };

  useEffect(() => {
    handleChange(filter);
  }, [filter]);

  const handleChange = async (newAlignment) => {
    await app.field("%Selecao").selectMatch(newAlignment);
    setAlignment(newAlignment);
  };

  return (
    <div className="app investments">
      <div className="appContent">
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div
            style={{
              display: "flex",
              width: "100%",
              padding: "0 8px",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h1
              style={{
                marginLeft: "10px",
              }}
            >
              {alignment}
            </h1>
          </div>

          <Card
            header={{
              hardTitle: "Regionais",
              tooltip: tooltips["Regionais"][alignment],
            }}
            style={{
              width: "100%",
              height: "500px",
            }}
          >
            <NativeObject app={app} key="qNSBJp" reference={{ id: "qNSBJp" }} />
          </Card>
          <Card
            header={{
              hardTitle: "Grupos Distribuidores",
              tooltip: tooltips["Grupos Distribuidores"][alignment],
            }}
            style={{
              width: "100%",
              height: "500px",
            }}
          >
            <NativeObject app={app} key="YDypPM" reference={{ id: "YDypPM" }} />
          </Card>

          <Card
            exportTable
            app={app}
            exportContainer
            exportTableId="VZezD"
            header={{
              hardTitle: "Detalhamento",
              tooltip: tooltips["Detalhamento"][alignment],
            }}
            style={{ width: "100%",  height: "500px", alignItems: "center" }}
          >
            <NativeObject
              app={app}
              key="VZezD"
              reference={{ id: "VZezD" }}
              style={{ marginTop: "20px" }}
            />
          </Card>
        </div>
      </div>
    </div>
  );
}

GeneralMobile.defaultProps = {
  app: null,
  config: {},
  filter: "",
};

GeneralMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  filter: PropTypes.string,
};

export default GeneralMobile;
